import { render, staticRenderFns } from "./ParamScaleDiseaseList.vue?vue&type=template&id=76a95ae4&scoped=true"
import script from "./ParamScaleDiseaseList.vue?vue&type=script&lang=js"
export * from "./ParamScaleDiseaseList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76a95ae4",
  null
  
)

export default component.exports